
<template>
	<div ref="listWrap">
		<wrapper-list 
     @calculate="paasCalculate"
     @send="paasSendCoupon"
		 ref="wrapperList" >
      	<Form class="list-query-wrap" slot="query"
              :model="queryParam"
              :label-width="defaultLabelWidth"
              ref="queryForm">
          <row class="list-query-row">
            <FormItem label="会员号:" class="list-query-item">
              <Input  v-model="queryParam.query_LIKE_userCode" placeholder="会员号"
                @on-change="queryTableDatas('param')" clearable />
            </FormItem>
            <FormItem label="用户昵称:" class="list-query-item">
                  <Input  v-model="queryParam.query_LIKE_nickname" placeholder="用户昵称"
                          @on-change="queryTableDatas('param')" clearable />
            </FormItem>
            <FormItem label="真实姓名:" class="list-query-item">
                  <Input  v-model="queryParam.query_LIKE_realName" placeholder="真实姓名"
                          @on-change="queryTableDatas('param')" clearable />
            </FormItem>

          </row>
          <row class="list-query-row">
              <FormItem label="手机号码:" class="list-query-item">
                  <Input  v-model="queryParam.query_LIKE_phone" placeholder="手机号码"
                          @on-change="queryTableDatas('param')" clearable />
              </FormItem>
              <FormItem label="推广人:" class="list-query-item">
                  <Input  v-model="queryParam.query_LIKE_spreadName" placeholder="推广人"
                          @on-change="queryTableDatas('param')" clearable />
              </FormItem>
              <FormItem label="性别:" class="list-query-item">
                  <Enum :enumJsonKey="'crmdict-gender'"  v-model="queryParam.query_EQ_gender"
                        @on-change="queryTableDatas('param')" type="radio">
                  </Enum>
              </FormItem>

          </row>
      	</Form>
      	<Table slot="table" stripe border :height="tableHeight"
             :data="tableData"
             :columns="tableColumns"
             @on-selection-change="selectTableDataChange"
             @on-sort-change="sortTableData"
             :no-data-text="noDataText">
        </Table>
        <Page slot="page"  :total="totalRecords"
            show-total show-sizer
            @on-change="changePage"
            @on-page-size-change="changePageSize">
        </Page>
    </wrapper-list>
   </div>
</template>
<script>
	import wrapperList from "@components/paas/wrapper-list";
    import metaList from "@assets/js/list/meta-list.js";
    import EnumShow from "@components/paas/enum-show";  //如果有枚举，需要引入
    import Enum from '@components/paas/query-enum' //枚举查询
    import CellBar from '@components/paas/cell-bar' //列表内操作
    import QueryDate from '@components/paas/query-date' //日期
    export default {
      name: "list",
      mixins: [ metaList ],
      components: { wrapperList,EnumShow,Enum,CellBar,QueryDate},
      data() {
      	return {
            serviceUrl:"/eb/user",  //每个页面访问后台服务器的路径
            currentIdFiledName: 'id',
            queryParam:{
                query_LIKE_userCode:"",
                query_LIKE_realName:'',
                query_LIKE_nickname:"",
                query_LIKE_phone:"",
                query_EQ_gender:"", //性别(2 女 1 男)
                query_LIKE_spreadName:"",
            },
	        defaultLabelWidth:150,
            tableColumns:[
	        	{
	              type: 'index',  //type: 'index'，可以排序
	              width: 40,
	              align: 'center',
	            },
                {
                    title:"会员号",
                    key:"userCode",
                    width:80,
                },
	        	{
	        		title: '头像',
	        		key: 'avatar',
                    align:'center',
                    width:70,
                    render:(h,params)=>{
                        if(params.row.avatar){
                          return h('img',{
                            attrs: {
                              src: params.row.avatar,
                            },
                            style:{
                              width:"45px",
                              height:"45px",
                              marginTop:"5px"
                            }
                          })
                        }
                    }
	        	},
	        	{
	        		title: '昵称',
	        		key: 'nickname',
                    align:'center',
                    width:120,
	        	},
                {
                    title: '姓名',
                    key: 'realName',
                    align:'center',
                    width:120,
                },
	        	{
	        		title: '手机号',
	        		key: 'phone',
                    align:'center',
                    width:120,
	        	},
                {
                    title: '性别',
                    key: 'gender',
                    align:'center',
                    width:50,
                    render:(h,params)=>{
                        return h(EnumShow,{
                            props:{
                                enumGroupCode:'crmdict',
                                enumCode:'gender',
                                value:params.row.gender
                            }
                        })
                    }
                },
                {
                    title: '生日',
                    key: 'birthday',
                    align:'center',
                    width:100,
                },
	        	{
	        		title: '余额',
	        		key: 'nowMoney',
                    align:'center',
                    width:80,
	        	},
                {
                    title: '推广类型',
                    key: 'isPromoter',
                    align:'center',
                    width:120,
                    render:(h,params)=>{
                        return h(EnumShow,{
                            props:{
                                enumGroupCode:'crmdict',
                                enumCode:'isPromoter',
                                value:params.row.isPromoter
                            }
                        })
                    }
                },
                {
                  title: '级别',
                  key: 'level',
                  align:'center',
                  width:60,
                },
                {
                   title: '累计消费额',
                   key: 'totalConsum',
                   align:'center',
                   width:120,
                },
	        	{
	        		title: '积分',
	        		key: 'integral',
                    align:'center',
                    width:60,
	        	},
	        	{
	        		title: '推荐人',
	        		key: 'spreadUid',
                    align:'center',
                    width:80,
                    render:(h,params)=>{
                        let spread = params.row.spreadName;
                        if(!params.row.spreadUid){
                          spread = "无";
                        }
                       return h('span',{},spread)
                    }
	        	},
                {
                   title: '状态',
                   key: 'status',
                   width:100,
                   render:(h,params)=>{
                     return h('i-switch', {
                       class:"sale-status",
                       props:{
                         type: 'primary',
                         size:'large',
                         value: params.row.status,  //控制开关的打开或关闭状态，官网文档属性是value
                         'true-value': "1",
                         'false-value':"0",
                       },
                       on: {
                         'on-change': (value) => {
                           params.row.status = value;
                           //实时保存数据
                           this.updateUserStatus(params.row);
                         }
                       }
                     },[
                       h('span', {
                         slot: 'open',
                         domProps: {
                           innerHTML: '正常'
                         }
                       }),
                       h('span', {
                         slot: 'close',
                         domProps: {
                           innerHTML: '禁止'
                         }
                       }),
                     ])
                   }
                },
	        	{	
	        		title: '操作',
                    width:'180',
	        		render: (h, params) => {
                    return h(CellBar,
                      {
                      props:{
                        show:'text'  //操作也显示标准按钮的样式（text、icon、textIcon）
                      },
                      //自定义事件监听器“on”,不支持如v-on:keyup.enter的修饰符，需要手动匹配keyCode
                        on: {
                          // 子组件$emit传递函数,必须是箭头函数写法
                          'edit': ()=> {
                            this.$nextTick(()=>{
                              this.paasEditOper(params.row[this.currentIdFiledName]);
                            })
                          },
                          'delete':()=>{
                            this.$nextTick(()=>{
                              this.paasDeleteOper(params.row[this.currentIdFiledName]);
                            })
                          },
                          /**
                           * 余额积分
                           */
                          'integral':()=>{
                            this.$nextTick(()=>{
                              this.paasEditOper(params.row[this.currentIdFiledName],"/eb/user/integral");
                            })
                          },
                          'detail':()=>{
                            this.$nextTick(()=>{
                              this.paasEditOper(params.row[this.currentIdFiledName],"/eb/user/detail");
                            })
                          },
                          'member':()=>{
                            this.$nextTick(()=>{

                            })
                          }
                        }
                    }
                )}
		       }
	        ],
      	}
      },
      mounted(){
      },
      methods:{
        changeUserInfo(){

        },
        updateUserStatus(row){

        },
        /**
         * 发送优惠券
         * */
        paasSendCoupon(){
          let selectedDatas = this.tableSelectedDatas;
          if(selectedDatas.length === 0) {
            this.$Message.warning('请选择要发布优惠券的会员！');
          }
          else {
            let userIdStr = "";
            for(let i = 0; i < this.tableSelectedDatas.length; i++){
              userIdStr += this.tableSelectedDatas[i].uid;
              if(i !== this.tableSelectedDatas.length-1){
                userIdStr += ",";
              }
            }
            this.paasEditOper(selectedDatas[0][this.currentIdFiledName],"/eb/store/coupon/sendCoupon?userIdStr="+userIdStr);
          }
        },
      }
    } 
</script>
